import { render } from "./Header.vue?vue&type=template&id=d2a2788e&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=d2a2788e&lang=scss&scoped=true"

import exportComponent from "/Users/fci/Downloads/traininGulftic-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2a2788e"]])

export default __exports__